import { AuthClientConfig } from '@auth0/auth0-angular';
import { APP_CONFIG, AppConfiguration } from '@app/infrastructure/auth/app-configuration';
import { auth0Config } from '@core/configs/auth0.config';
import { APP_INITIALIZER } from '@angular/core';

function auth0Initializer(appConfiguration: AppConfiguration, authClientConfig: AuthClientConfig): () => void {
	return () => {
		authClientConfig.set({
			...auth0Config,
			...appConfiguration.auth,
		});
	};
}

export const CONFIG_INITIALIZER_PROVIDER = {
	provide: APP_INITIALIZER,
	multi: true,
	useFactory: auth0Initializer,
	deps: [APP_CONFIG, AuthClientConfig],
};
